import { apiClient } from "@/lib/lutely-api/api-request";
import type { UserPayloadDto } from "@/lib/lutely-api/gen/dtos";

// The backend field ships with the LUT-941 API change; until `npm run codegen`
// regenerates the client, read it through this helper instead of the DTO type.
export function userRequiresPolicyConsent(
  user: UserPayloadDto | undefined,
): boolean {
  const flag = (
    user as (UserPayloadDto & { requiresPolicyConsent?: boolean }) | undefined
  )?.requiresPolicyConsent;
  return flag === true;
}

export type PolicyAcceptance = {
  policyVersion: string;
  acceptedAt: string;
};

export async function acceptPolicies(): Promise<PolicyAcceptance> {
  const response = await apiClient.post<PolicyAcceptance>(
    "/auth/accept-policies",
  );
  return response.data;
}
